module.exports = __webpack_public_path__ + "static/media/tracking-progress.b9e62d1f.png";